import service from '../utils/axios';
import { setAuthorizationToken } from '../utils/axios';
import { API_URL } from '../const/const';

export function surveyDataReceived(data) {
  return {
    type: 'DATA_RECEIVED',
    data
  };
}

export function fetchSurveyData(hash) {
  console.log(API_URL);

  return function (dispatch) {
    const url = `${API_URL}/auth/${hash}`;
    return service.post(url, { hash })
      .then((res) => {
        if (res.data.success) {
          setAuthorizationToken(res.data.success.token);
          dispatch(surveyDataReceived(res.data.success));
        } else if (res.data.error) {
          dispatch(fetchingError(res.data.error));
        }
      })
      .catch((error) => {
        dispatch(fetchingError(error.message));
      });
  };
}

export function fetchingError(error) {
  return {
    type: 'FETCH_ERROR',
    error
  };
}
